/* NIKVO — interacciones propias (sin librerías) */
(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.nk-reveal:not(.nk-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('nk-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('nk-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initGalleries() {
    document.querySelectorAll('[data-nk-gal]').forEach(function (gal) {
      if (gal.dataset.nkReady) return;
      gal.dataset.nkReady = '1';
      var main = gal.querySelector('[data-nk-main]');
      gal.querySelectorAll('[data-nk-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          gal.querySelectorAll('[data-nk-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (!main) return;
          main.style.opacity = '0';
          setTimeout(function () {
            main.src = btn.dataset.src;
            main.srcset = '';
            main.alt = btn.dataset.alt || '';
            main.style.opacity = '1';
          }, 180);
        });
      });
    });
  }

  function formatMoney(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return (fmt || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount\s*\}\}/, withDot)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
  }

  function initProduct() {
    document.querySelectorAll('[data-nk-product]').forEach(function (root) {
      if (root.dataset.nkReady) return;
      root.dataset.nkReady = '1';
      var dataEl = root.querySelector('[data-nk-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var fmt = root.dataset.moneyFormat;
      var form = root.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var priceNow = root.querySelector('[data-nk-price]');
      var priceOld = root.querySelector('[data-nk-compare]');
      var addBtn = root.querySelector('[data-nk-add]');
      var addLabel = addBtn ? addBtn.dataset.label : '';
      var soldLabel = addBtn ? addBtn.dataset.sold : '';
      var msg = root.querySelector('[data-nk-msg]');

      function current() {
        var opts = [];
        root.querySelectorAll('[data-nk-option]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          opts.push(c ? c.value : null);
        });
        if (!opts.length) return variants[0];
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      function update(fromUser) {
        var v = current();
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.querySelector('span').textContent = soldLabel; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceNow) priceNow.textContent = formatMoney(v.price, fmt);
        if (priceOld) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            priceOld.textContent = formatMoney(v.compare_at_price, fmt);
            priceOld.hidden = false;
          } else { priceOld.hidden = true; }
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.querySelector('span').textContent = v.available ? addLabel : soldLabel;
        }
        if (fromUser === true && v.featured_media && v.featured_media.id) {
          var t = root.querySelector('[data-nk-thumb][data-media-id="' + v.featured_media.id + '"]');
          if (t) t.click();
        }
        if (fromUser === true) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          } catch (e) {}
        }
      }

      root.querySelectorAll('[data-nk-option] input').forEach(function (inp) {
        inp.addEventListener('change', function () { update(true); });
      });

      root.querySelectorAll('[data-nk-qty]').forEach(function (q) {
        var input = q.querySelector('input');
        q.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(input.value, 10) || 1;
            n = b.dataset.step === 'up' ? n + 1 : Math.max(1, n - 1);
            input.value = n;
          });
        });
      });

      if (form) {
        form.addEventListener('submit', function (ev) {
          if (!window.fetch) return;
          ev.preventDefault();
          if (addBtn) addBtn.disabled = true;
          if (msg) msg.textContent = '';
          var fd = new FormData(form);
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && cartDrawer.getSectionsToRender) {
            fd.append('sections', cartDrawer.getSectionsToRender().map(function (s) { return s.id; }));
            fd.append('sections_url', window.location.pathname);
          }
          fetch('/cart/add.js', {
            method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (addBtn) addBtn.disabled = false;
            if (res.status) { if (msg) msg.textContent = res.description || res.message; return; }
            if (cartDrawer && cartDrawer.renderContents && res.sections) {
              cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(res);
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
          }).catch(function () { form.submit(); });
        });
      }

      update(false);
    });
  }

  function initPackForms() {
    document.querySelectorAll('form.nk-quick').forEach(function (form) {
      if (form.dataset.nkReady) return;
      form.dataset.nkReady = '1';
      form.addEventListener('submit', function (ev) {
        var cartDrawer = document.querySelector('cart-drawer');
        if (!window.fetch || !cartDrawer || !cartDrawer.renderContents) return;
        ev.preventDefault();
        var fd = new FormData(form);
        fd.append('sections', cartDrawer.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' } })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { form.submit(); return; }
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(res);
          }).catch(function () { form.submit(); });
      });
    });
  }

  function initAll() { initReveal(); initGalleries(); initProduct(); initPackForms(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
